import {BaseModule} from './base.module';
import {DocumentLanguageModule} from './document-language.module';
import {StorageModule} from './storage.module';

/**
 * Speak, friend, and enter
 */
export class TextToSpeechModule extends BaseModule {

    hasSpeechSynthesis = false; // default to not
    enabled = false;
    mouseTargets = [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'p',
        'blockquote',
        'svg',
        'span',
        'li',
        'img',
        'input',
        'select',
        'textarea',
        'a',
        'button',
        'label',
        'strong',
    ];
    inputTargets = [
        'label',
        'input',
        'select',
        'textarea',
        'a',
        'button',
    ];
    storageModule = new StorageModule();
    documentLanguageModule = new DocumentLanguageModule();
    // language = this.documentLanguageModule.getLanguageFromDocument();
    language = 'nl-NL';
    textToSpeechLoaded = false;

    constructor() {
        super();
    }

    initialize() {
        this.setEventListeners();
    }

    setEventListeners() {
        console.log('[TextToSpeechModule] setEventListeners');
        document.addEventListener('touchstart', () => {
            console.log('[TextToSpeechModule] setEventListeners touchstart');
            this.touchCompatible = true;
        });
        if (speechSynthesis.onvoiceschanged !== undefined) {
            speechSynthesis.onvoiceschanged = this._setup();
            this.triggerEventOnElement('text-to-speech-loaded-old', document, {
                voices: this.voices
            });
            //if, after _setup, the voices are still null, we failed loading. Try the modern approach now
            if (typeof this.voices.length > 0) {
                console.log('voices loaded!', this.voices);
                this.textToSpeechLoaded = true;
            } else {
                console.log('no voices loaded... :(', this.voices);
            }
            if (this.textToSpeechLoaded == false) {
                console.log('now trying modern approach...');
                window.speechSynthesis.addEventListener('voiceschanged', () => {
                    console.log('[TextToSpeechModule] voiceschanged');
                    console.log('[TextToSpeechModule] synth object', window.speechSynthesis);
                    this._setup();
                    this.triggerEventOnElement('text-to-speech-loaded-new', document, {
                        voices: this.voices
                    });
                });
            }
        }
    }

    handleActivation() {
        this.enabled = true;
    }

    handleDeactivation() {
        this.enabled = false;
    }

    /**
     * Internal API, this method _setup below here should only be called from this module
     */
    _setup() {
        console.log('[TextToSpeechModule] _setup', this.voices, this.language, window.speechSynthesis);
        if (typeof window.speechSynthesis !== 'undefined' && typeof window.speechSynthesis.getVoices !== 'undefined') {
            this.voices = window.speechSynthesis.getVoices();
            for (let i = 0; i < this.voices.length; i++) {
                let voice = this.voices[i];
                if (voice && voice.lang) {
                    if (voice.lang == this.language) {
                        console.log('[TextToSpeechModule] found a matching voice language', this.language, voice.lang);
                        this.voice = this.voices[i]; // assign a matching language voice
                        break;
                    }
                }

            }
            if (typeof this.voice == 'undefined' && this.voices.length && this.voices.length > 0) {
                console.log('[TextToSpeechModule] no matching voice found for language', this.language, ', falling back to the first reported voice');
                this.voice = voice[0];
            }

            // delegated handlers: otherwise newly created elements will not be announced
            // focusable targets, that will actually do something when they receive focus (inputs)


            document.addEventListener('focus', (event) => {
                // input targets
                // console.log('focus target', event.target, 'localName', event.target.localName);
                this.inputTargets.forEach((target) => {
                    if (event.target.localName == target) {
                        this.handleElementFocus(event);
                    }
                });
                this.inputTargets;
            });
            document.addEventListener('blur', (event) => {
                // input targets
                // console.log('blur target local name', event.target.localName);
                this.inputTargets.forEach((target) => {
                    if (event.target.localName == target) {
                        this.handleElementBlur(event);
                    }
                });
                this.inputTargets;
            });
            document.addEventListener('mouseover', (event) => {
                // mouse targets
                // console.log('mouseover target local name', event.target.localName);
                this.mouseTargets.forEach((target) => {
                    if (event.target.localName == target) {
                        this.handleElementFocus(event);
                    }
                });
                this.mouseTargets;
            });


            let ttsEnabled = this.storageModule.getItem('localStorage', 'text-to-speech');
            switch (ttsEnabled) {
                case '1':
                    this.handleActivation();
                    this.introduce();
                    break;
                case '0':
                    break;
            }

            this.hasSpeechSynthesis = true;
        } else {
            this.hasSpeechSynthesis = false;
        }
        // console.log('_setup', this.voices);
    }

    handleInputFocus(event) {
        let placeholder = event.target.placeholder;
        let inputValue = ``;
        let labelText = ``;
        let inputType = ``;
        let p = `met plaatshouder ${placeholder}`;
        if (typeof placeholder !== 'undefined' && placeholder.length > 0) {
            placeholder = p;
        }
        if (
            typeof event.target !== 'undefined' &&
            typeof event.target.value !== 'undefined' &&
            typeof event.target.value.length > 0
        ) {
            inputValue = `de waarde is nu ${event.target.value}`;
        }

        console.log('event.target.type', event.target.type);
        if (
            typeof event.target !== 'undefined' &&
            typeof event.target.type !== 'undefined'
        ) {
            let readableType = `${event.target.type}`;
            switch (event.target.type) {
                case 'email':
                    readableType = `e-mail`;
                    break;

                default:
                    break;
            }
            inputType = `van type ${readableType}`;
        }

        if (event.target.parentNode) {
            let label = event.target.parentNode.querySelector('label');
            if (label) {
                console.log('label...', label);
                labelText = `met label ${label.textContent}`;
            } else {
                labelText = event.target.parentNode.textContent;
            }
        }

        this.speak(`Invoerveld ${inputType} ${labelText} ${placeholder}, ${inputValue}`);
    }

    handleElementFocus(event) {
        // console.log('focus-like event received', event);
        if (this.enabled == true) {
            window.speechSynthesis.cancel(); // cancel any already uttering voices
            console.log('enabled?', this.enabled);
            let elementType = 'element';
            let textContent = event.target.textContent;
            if (typeof event.target.localName !== 'undefined') {
                console.log('local name:', event.target.localName);
                switch (event.target.localName) {
                    case 'h1':
                    case 'h2':
                    case 'h3':
                    case 'h4':
                    case 'h5':
                    case 'h6':
                        elementType = 'Titel';
                        break;
                    case 'p':
                        elementType = 'Paragraaf';
                        // this.handleInputFocus(event);
                        // let closestInput = event.target.closest('input');
                        // if (closestInput) {
                        //     elementType = 'Eenvoudig invoerveld binnen paragraaf';
                        //     this.handleInputFocus(event);
                        // }
                        break;
                    case 'span':
                        elementType = 'Inline element';
                        break;
                    case 'blockquote':
                        elementType = 'Citaat';
                        break;
                    case 'cite':
                        elementType = "Geciteerde";
                    case 'ol':
                        elementType = "Geördende lijst";
                    case 'ul':
                        elementType = "Ongenummerde lijst";
                        break;
                    case 'li':
                        elementType = "lijst-item";
                        break;
                    case 'a':
                        elementType = 'Link';
                        break;
                    case 'button':
                        elementType = 'Knop';
                        break;
                    case 'strong':
                        elementType = 'Belangrijke tekst';
                        break;
                    case 'small':
                        elementType = 'Kleine tekst';
                        break;
                    case 'img':
                        elementType = 'Afbeelding';
                        // alert('img');
                        break;
                    case 'input':
                        elementType = 'Eenvoudig invoerveld';
                        this.handleInputFocus(event);
                        break;
                    case 'label':
                        elementType = 'Label';
                        break;
                    case 'svg':
                    case 'use':
                        elementType = 'Grafisch element';
                        let closestLink = event.target.closest('a');
                        if (closestLink && closestLink.hasAttribute('title') === true) {
                            this.speak(`De titel van het grafische element binnen deze link is: ${closestLink.getAttribute('title')}. Het link doel is ${closestLink.href}`);
                        }
                        let queryTitle = event.target.querySelector('title');
                        console.log('queryTitle', queryTitle);
                        if (queryTitle) {
                            textContent = queryTitle.textContent;
                            this.speak(`Een schaalbare afbeelding: ${textContent}`);
                        }
                        if (event.target.localName === 'use') {
                            queryTitle = event.target.parentNode.querySelector('title')
                            if (queryTitle) {
                                textContent = queryTitle.textContent;
                                this.speak(`Een schaalbare afbeelding, de titel is: "${textContent}"`);
                            }
                        }
                        break;

                }
            }
            if (typeof textContent !== 'undefined' && textContent.length > 0) {
                this.speak(`${elementType}: ${textContent}`);
            } else {
                this.speak(`${elementType}`);
            }
            if (event.target.localName == 'a' && typeof event.target.href !== 'undefined' && typeof event.target.href !== null) {
                let href = event.target.href;
                href.replace('.', ' punt ');
                href.replace('nl', 'NL');
                this.speak(`Het link doel is: ${href}`);
            }
            if (event.target.hasAttribute('title') && event.target.getAttribute('title').length > 0) {
                this.speak(`De titel van dit element is: ${event.target.getAttribute('title')}`);
            }
            if (event.target.hasAttribute('alt') && event.target.getAttribute('alt').length > 0) {
                this.speak(`De alternatieve tekst van dit element is: ${event.target.getAttribute('alt')}`);
            }
        }
    }

    handleElementBlur(event) {
        if (this.enabled == true) {
            // console.log('blur-like event received', event);
            if (event && typeof event.target !== 'undefined') {
                window.speechSynthesis.cancel();
            }
        }
    }

    introduce() {

        let introduced = this.storageModule.getItem('sessionStorage', 'introduced-text-to-speech-accessibility');

        console.log('introduced?', introduced);

        if (introduced == null) {
            this.speak(`Welkom in de toegankelijkheidsweergave van website "${window.location.hostname}."`);
            if (this.touchCompatible == false) {
                // if no touchstart was triggered before, then announce a message about mouse & keyboard for TAB-nav
                this.speak(`Klik met de muis op elementen om meer informatie te verkrijgen.`);
                this.speak(`Gebruik toetsenbordnavigatie om te navigeren naar knoppen.`);
            }
            if (this.touchCompatible == true) {
                this.speak(`Tik op elementen om meer informatie te verkrijgen.`);
            }
            this.speak(`Als je opnieuw deze uitleg wilt horen, sluit dan alle vensters van deze browser.`);
            this.speak(`Nu volgt uitleg over de pagina.`);
        }
        this.speak(`Paginatitel: "${document.title}".`);
        if (window.location.pathname == '/') {
            this.speak(`Je bent op de hoofdpagina van deze website.`);
        }
        if (window.location.pathname.length > 1) {
            this.speak(`De subpagina is ${window.location.pathname}`);
        }
        let h1 = document.documentElement.querySelector('h1');
        let h2 = document.documentElement.querySelector('h2');
        let h3 = document.documentElement.querySelector('h3');
        let h4 = document.documentElement.querySelector('h4');
        let h5 = document.documentElement.querySelector('h5');
        let h6 = document.documentElement.querySelector('h6');
        if (h1) {
            this.speak(`De eerste belangrijke titel is ${h1.textContent}`);
        }
        if (h2) {
            this.speak(`De tweede belangrijke titel is ${h2.textContent}`);
        }
        if (h3) {
            this.speak(`De derde belangrijke titel is ${h3.textContent}`);
        }
        if (h4) {
            this.speak(`De vierde belangrijke titel is ${h4.textContent}`);
        }
        if (h5) {
            this.speak(`De vijfde belangrijke titel is ${h5.textContent}`);
        }
        if (h6) {
            this.speak(`De zesde belangrijke titel is ${h6.textContent}`);
        }

        this.storageModule.setItem('sessionStorage', 'introduced-text-to-speech-accessibility', true);
        console.log('introduced? after setting it', introduced);
    }

    speak(utterance) {
        if (this.voice) {
            this.utterance = new SpeechSynthesisUtterance(utterance);
            this.utterance.voice = this.voice;
            window.speechSynthesis.speak(this.utterance);
        } else {
            console.log('[TextToSpeechModule] no matching voice found to utter', utterance);
        }
    }
}
